import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./Alert.module.css";

interface AlertProps {
	warning?: boolean;
	error?: boolean;
	rounded?: boolean;
	icon?: IconDefinition;
	className?: string;
}

export default function Alert({
	warning,
	error,
	rounded,
	icon,
	className,
	children,
}: React.PropsWithChildren<AlertProps>) {
	return (
		<div
			className={cx(styles.alert, className, {
				[styles.warning]: warning,
				[styles.error]: error,
				[styles.rounded]: rounded,
			})}
		>
			{icon && <FontAwesomeIcon icon={icon} />}
			{children}
		</div>
	);
}
